// extracted by mini-css-extract-plugin
module.exports = {"powder":"PowderPile_powder__1NtkS"};